<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="540px" scrollable>
      <v-card class="py-6" style="border: 1px solid #363949">
        <v-row no-gutters class="px-6">
          <v-col cols="10">
            <span class="drmModalMainTitle textType3--text">
              {{ $t('message.pages.drmModalDashboard.title') }}
            </span>
            <br />
            <span class="drmModalSubtitleText textType6--text">
              {{ $t('message.pages.drmModalDashboard.subtitle') }}
            </span>
          </v-col>
          <v-col cols="2" class="d-flex flex-row align-center justify-end">
            <v-icon style="cursor: pointer" @click="handleClose()">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        <v-card-text
          style="height: 210px"
          class="pa-0 pl-4"
          :class="drmGroups.length > 3 ? 'pr-2' : 'pr-6'"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              v-for="(group, i) in drmGroups"
              class="d-flex flex-row align-center py-4"
              :key="i"
              :style="
                drmGroups.length > 1 ? 'border-bottom: 1px solid #EDEEF1' : ''
              "
            >
              <v-row no-gutters>
                <v-card
                  class="d-flex align-center justify-center mr-1"
                  flat
                  color="background"
                >
                  <v-btn icon @click="handleActiveGroup(group)">
                    <v-card
                      class="d-flex align-center justify-center elevation-0 rounded-pill"
                      width="20px"
                      height="20px"
                      :color="
                        group.isActive
                          ? '#3F55EE'
                          : $vuetify.theme.dark
                          ? '#000000'
                          : '#FFFFFF'
                      "
                      :style="
                        group.isActive
                          ? ''
                          : $vuetify.theme.dark
                          ? 'border: 2px solid #52577A'
                          : 'border: 2px solid #D0D1D9'
                      "
                    >
                      <v-card
                        v-if="group.isActive"
                        :color="
                          group.isActive
                            ? '#FFFFFF'
                            : !$vuetify.theme.dark
                            ? '#000000'
                            : '#FFFFFF'
                        "
                        width="10px"
                        height="10px"
                        flat
                        class="rounded-pill"
                      ></v-card>
                    </v-card>
                  </v-btn>
                </v-card>
                <v-col class="d-flex align-center justify-start">
                  <span
                    :title="group.name"
                    class="text-truncate drmModalSubtitleText textType3--text"
                    style="max-width: 470px"
                  >
                    {{ group.name }}
                  </span>
                </v-col>
                <v-card
                  v-if="!group.value"
                  class="d-flex align-center justify-end mr-3"
                  flat
                  color="background"
                  width="125px"
                >
                  <v-card
                    :color="`${
                      $vuetify.theme.dark
                        ? group.webhook_source_name
                          ? '#363949'
                          : '#1B5E20'
                        : group.webhook_source_name
                        ? '#ABADBA'
                        : '#C8E6C9'
                    }`"
                    class="statusText rounded-pill px-2 py-0"
                    flat
                  >
                    <span
                      :style="`${
                        $vuetify.theme.dark
                          ? group.webhook_source_name
                            ? 'color: #666D99'
                            : 'color: #DCEFDD'
                          : group.webhook_source_name
                          ? 'color: #EDEEF1'
                          : 'color: #174F1B'
                      }`"
                      class="caption"
                    >
                      {{
                        group.webhook_source_name
                          ? group.webhook_source_name.charAt(0).toUpperCase() +
                            group.webhook_source_name.slice(1)
                          : 'API'
                      }}
                    </span>
                  </v-card>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-6 pt-6 pb-1">
          <v-spacer></v-spacer>
          <v-btn
            class="elevation-0 px-3 rounded-lg"
            color="btnBgCancel"
            height="40px"
            @click="handleClose"
            :disabled="isFetching"
          >
            <span>{{ $t('message.cancel') }}</span>
          </v-btn>
          <v-btn
            class="elevation-0 rounded-lg"
            height="40px"
            color="btnBg"
            :loading="isFetching"
            :disabled="isFetching"
            @click="handleConfirm"
          >
            <span class="px-3 white--text">{{ $t('message.confirm') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapMutations } from 'vuex/dist/vuex.common.js'

export default {
  name: 'DrmModalDashboard',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    drmGroups: [],
    startValueDrmGroups: [],
    selectedGroups: [],
    selectedItem: null,
    initialActiveItem: null,
  }),
  watch: {
    open(val) {
      if (val === false) this.$root.$emit('DrmModalHasClosed')
    },
  },
  mounted() {
    this.$root.$on('finishUpdateFolderVideosPage', () => {
      this.isFetching = false
      this.handleClose()
    })
    this.$root.$on('drmModalDashboard', (data) => {
      Object.assign(this.$data, this.initialState())
      this.setInfo(data.groups, data.item)
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('finishUpdateFolderVideosPage')
    this.$root.$off('drmModalDashboard')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    checkIfSelected(group) {
      let foundItem = this.selectedGroups.find((searchedItem) => {
        return searchedItem.id === group.id
      })
      if (foundItem) return true
      return false
    },
    handleActiveGroup(activateGroup) {
      if (activateGroup.isActive) return
      this.drmGroups = this.drmGroups.map((group) => {
        if (group.id === activateGroup.id) {
          group.isActive = !group.isActive
        } else if (group.isActive) {
          group.isActive = false
        }
        return group
      })
    },
    setInfo(groups, item) {
      this.selectedItem = item
      if (this.selectedItem.drm_group_ids) {
        let fixedGroups = groups.map((group) => {
          let foundGroup = this.selectedItem.drm_group_ids.find(
            (el) => el.drm_group_id === group.id
          )
          return { ...group, isActive: !!foundGroup }
        })
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      } else {
        let fixedGroups = groups.map((group) => ({ ...group, isActive: false }))
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      }
      this.drmGroups.push({
        name: this.$i18next.t('message.pages.drmModalDashboard.none'),
        value: 'none',
        isActive: !this.selectedItem.drm_group_ids,
      })
      this.initialActiveItem = this.drmGroups.find((item) => item.isActive)
    },
    updateSnackbar() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$i18next.t('message.pages.drmModalDashboard.updateSuccess'),
        type: 'success',
      })
    },
    async handleConfirm() {
      this.isFetching = true
      this.getNewGroups()
    },
    async removeFromAllGroups() {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      let removingIds = this.selectedItem.drm_group_ids.map(
        (item) => item.drm_group_id
      )
      for (let removingId of removingIds) {
        try {
          await drmApi.drmUpdateVideos(removingId, modifiedData)
          this.selectedItem.drm_group_ids =
            this.selectedItem.drm_group_ids.filter(
              (item) => item.drm_group_id != removingId
            )
          if (!this.selectedItem.drm_group_ids.length)
            delete this.selectedItem['drm_group_ids']
        } catch (e) {
          console.log('e', e)
        }
      }
      this.updateSnackbar()
      this.handleClose()
    },
    getNewGroups() {
      let noGroup = this.drmGroups.find((group) => group.value === 'none')
      if (noGroup.isActive) {
        if (this.initialActiveItem?.value === 'none') {
          this.updateSnackbar()
          this.handleClose()
          return
        }
        this.removeFromAllGroups()
        return
      }
      let startActiveArray = this.startValueDrmGroups.map(
        (group) => group.isActive
      )
      let newActiveArray = this.drmGroups.map((group) => group.isActive)
      let arrayIndexes = []
      for (let i = 0; i < startActiveArray.length; i++) {
        if (startActiveArray[i] !== newActiveArray[i]) {
          let indexedValue = i
          arrayIndexes.push(indexedValue)
        }
      }
      this.getGroupChanges(arrayIndexes)
    },
    async getGroupChanges(indexes) {
      let toBeAddedGroups = []
      let toBeRemovedGroups = []
      for (let index of indexes) {
        let changedGroup = this.drmGroups[index]
        if (this.selectedItem.drm_group_ids) {
          let findGroup = this.selectedItem.drm_group_ids.find(
            (group) => group.drm_group_id === changedGroup.id
          )
          if (findGroup) {
            toBeRemovedGroups.push(changedGroup)
          } else {
            toBeAddedGroups.push(changedGroup)
          }
        } else {
          toBeAddedGroups.push(changedGroup)
        }
      }
      for (let group of toBeRemovedGroups) {
        await this.removeItemFromGroup(group)
      }
      for (let group of toBeAddedGroups) {
        await this.addItemFromGroup(group)
      }
      this.updateInPage()
      if (!this.selectedItem.name) {
        this.isFetching = false
        this.updateSnackbar()
        this.handleClose()
      }
    },
    async addItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'increment',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'increment',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        let newObj = {
          active: group.active,
          drm_group_id: group.id,
        }
        if (this.selectedItem.drm_group_ids) {
          this.selectedItem.drm_group_ids.push(newObj)
        } else {
          this.selectedItem.drm_group_ids = [newObj]
        }
      } catch (e) {
        console.log('e', e)
      }
    },
    async removeItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        this.selectedItem.drm_group_ids =
          this.selectedItem.drm_group_ids.filter(
            (item) => item.drm_group_id != group.id
          )
        if (!this.selectedItem.drm_group_ids.length)
          delete this.selectedItem['drm_group_ids']
      } catch (e) {
        console.log('e', e)
      }
    },
    updateInPage() {
      if (this.selectedItem.name) {
        this.$root.$emit('updateFolderVideosPage', this.selectedItem)
      } else {
        this.$root.$emit('updateVideoVideosPage', this.selectedItem)
      }
    },
    handleClose() {
      this.open = null
      this.$root.$emit('resetIsAnyOtherModal')
    },
    initialState() {
      return {
        open: null,
        isFetching: false,
        drmGroups: [],
        startValueDrmGroups: [],
        selectedGroups: [],
        selectedItem: null,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.drmModalMainTitle {
  font-size: 18px;
  font-weight: 500;
}
.drmModalSubtitleText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}
</style>
